"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
exports.hasHeader = hasHeader;
var Headroom = require('headroom.js');
var config_1 = require("../config");
var Header = /*#__PURE__*/_createClass(function Header() {
  _classCallCheck(this, Header);
  this.header = null;
  this.headerElement = null;
  Headroom.prototype.shouldPin = function (currentScrollY, toleranceExceeded) {
    var pastOffset = currentScrollY <= this.offset,
      scrollingUp = currentScrollY < this.lastKnownScrollY;
    return scrollingUp && toleranceExceeded || pastOffset;
  };
  Headroom.prototype.shouldUnpin = function (currentScrollY, toleranceExceeded) {
    var pastOffset = currentScrollY >= this.offset,
      scrollingDown = currentScrollY > this.lastKnownScrollY;
    return scrollingDown && pastOffset && toleranceExceeded;
  };
  this.headerElement = document.querySelector(config_1.CONFIG.header.wrapper);
  this.header = new Headroom(this.headerElement, config_1.CONFIG.header.options);
  this.header.init();
});
exports.Header = Header;
function hasHeader() {
  if (document.querySelector(config_1.CONFIG.header.wrapper)) {
    return true;
  }
  return false;
}